module.exports = __webpack_public_path__ + "static/fragilite-enfant-68de8efc1848c52cb6202d0328a6a45f.svg";